import store from '@/store';
import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const namespace = 'uta_management_status-management';
const _module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export const registerStatusManagementStore = () => {
  if (!store.hasModule(namespace)) {
    store.registerModule(namespace, _module);
  }
};

export const unregisterStatusManagementStore = () => {
  if (store.hasModule(namespace)) {
    store.unregisterModule(namespace);
  }
};

export { namespace as statusManagementStore };
